export class ITable {
  exist: number;
  tables: any;
  orderFreeName: any;
}
export class TableDTO implements ITable {
  exist: number;
  tables: {
    orderLimitFood: number;
    orderLimitDrink: number;
    orderLimitTotal: number;
    orderLimitType: number;
    limitAlertTime: string;
    displayLimit: number;
    elapsedMinute: number;
    TBL_TBMCD: number;
    allYouCanEatLimit: string;
    TBL_START_TIME: string;
    TBL_FREE_START_TIME: string;
    TBL_DFREE: string;
    TBL_FREE: string;
  }[];
  orderFreeName: any;
}

export default class Table extends TableDTO {
  constructor(dto?: TableDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      exist: 0,
      tables: [],
      orderFreeName: []
    });
  }

  public getLimitAlertTime() {
    return (this.tables[0].limitAlertTime !== "") ? this.tables[0].limitAlertTime : "0"
  }

  public getRemainMinute(): number {
    if (this.tables[0] == undefined) {
      return 0;
    }
    const table = this.tables[0];
    const remainMinutes = Number.parseInt(table.allYouCanEatLimit) - table.elapsedMinute;

    return remainMinutes;
  }

  public getElapsedMinute(baseTime: Date): number {
    if (this.tables[0] == undefined) {
      return 0;
    }

    const startTimeFormatted: string = ("0000" + this.tables[0].TBL_START_TIME).slice(-4);

    const startTimeHour = Number.parseInt(startTimeFormatted.slice(0, 2));
    const startTimeMinute = Number.parseInt(startTimeFormatted.slice(2, 4));
    const startTime = startTimeHour * 60 + startTimeMinute;
    const now = baseTime.getHours() * 60 + baseTime.getMinutes();

    return now - startTime;
  }

  public getTableNo(): number {
    return ((this.tables[0]) && this.tables[0].TBL_TBMCD) ? this.tables[0].TBL_TBMCD : 0
  }
}
